import { Box, Chip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { connect } from "react-redux";
import { selectConstants, selectTags } from "../../redux/selectors/firebase";
import { getTagDisplayValue } from "../../utility/constantsTagsUtils";
import {Tags, Constants, ITag} from "./StateTags";
import {IStateMeta} from "../../fstn/state";
import {getBlockID} from "../../utility/blockNames";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(0.5),
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(0.5)
    }
}));

interface Props
{
    data: {
        meta: IStateMeta
    }
    state: string
    tags: Tags
    constants: Constants
}
function ChipTags({ data, state, tags, constants }: Props)
{
    const classes = useStyles();
    const stateTags = tags[state] ?? {};
    const convertStyle = (input: string) => input.replaceAll(/[ .]/g, "_");
    const filterChips = (tag: ITag) => {
        const constant = constants[tag.type];

        if (constant?.chip) {
            if (constant.chipValue && constant.type === "date") {
                return tag.value >= constant.chipValue;
            }
            return true;
        }
        return false;
    }

    return (
        <Box className={classes.container}>
            {Object.values(stateTags)
                .filter(tag => constants[tag.type]?.chip)
                .filter(filterChips)
                .map((tag, index) =>
                    <Chip key={index} className={`stylechip_${convertStyle(tag.type)}`}
                                 label={getTagDisplayValue(tag, constants)}/>
            )}
            {constants.blockName?.chip && data.meta.blockNames?.map(blockName =>
                <Chip key={blockName} className="stylechip_blockName" label={getBlockID(blockName)}/>
            )}
        </Box>
    );
}

const mapStateToProps = (store: never) => ({
    tags: selectTags(store) ?? {},
    constants: selectConstants(store) ?? {}
});
export default connect(mapStateToProps, {
})(ChipTags);